import React, {useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {submitUsername} from 'modules/authentication/actions';
import {excessiveLoginAttemptsSelector} from 'modules/authentication/selectors';

import CancelAndContinueButtons from 'components/Authentication/Controls/CancelAndContinueButtons';
import InputField from 'components/Authentication/Controls/InputField';
import AuthenticationContainer from 'components/Authentication/Steps/AuthenticationContainer';
import UnableToLogin from 'components/Authentication/UnableToLogin';

export default function Username() {

    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const excessiveAttempts = useSelector(excessiveLoginAttemptsSelector);

    const continueAction = () => {
        if (inputRef.current.value === '') {
            return;
        }

        dispatch(submitUsername(inputRef.current.value));
    };

    return <AuthenticationContainer title="Login">
        {excessiveAttempts && <UnableToLogin />}
        <InputField
            label="LexisNexis Portal - Login page — enter your username"
            placeholder="Username"
            type="text"
            inputRef={inputRef}
            required={true}
            autoFocus={true}
        />

        <CancelAndContinueButtons continueAction={continueAction}/>
    </AuthenticationContainer>;

}